<particle-treaty-document
  [isShowBreadcrumbs] = false
  [isShowActionItems] = false
  [isShowOtherDocumentOnly] = true
  [handler]="handler"
></particle-treaty-document>
